import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import BlurAmountView from 'design-system/BlurAmountView';
import IconLineUp from 'design-system/icons/IconLineUp';
import IconLineDown from 'design-system/icons/IconLineDown';
import { selectIsScrambled } from 'hooks';
import { useAppSelector } from 'store/hooks';
import useColors from 'hooks/useColors';
import { formatAmount } from 'utils/formatting';
const PriceChange = ({ priceChange, currency, isIncome }) => {
    const colors = useColors();
    const scrambled = useAppSelector(selectIsScrambled);
    if (!priceChange) {
        return null;
    }
    const increased = priceChange > 0;
    const positive = isIncome ? increased : !increased;
    const Icon = increased ? IconLineUp : IconLineDown;
    const iconColor = positive
        ? colors.elements.statusPositive
        : colors.elements.statusNegative;
    const textColor = positive
        ? { Positive: true }
        : { Negative: true };
    return (<View style={styles.container}>
      <Icon style={styles.icon} color={iconColor} width={16} height={16}/>
      <Text TextThin-14 {...textColor}>
        {increased ? 'Increased by' : 'Decreased by'}{' '}
      </Text>
      <BlurAmountView enabled={scrambled} containerStyle={styles.blurContainer}>
        <Text Numbers-14 {...textColor} numberOfLines={1}>
          {formatAmount(Math.abs(priceChange), currency, 2)}
        </Text>
      </BlurAmountView>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    blurContainer: {
        flexShrink: 1,
    },
    icon: {
        marginEnd: rem(8),
    },
});
export default memo(PriceChange);
